export default {
  info: 'informacion',
  bookingHolder: 'fat-boy-smiling',
  isHolder: 'fat-boy-smiling',
  bookingEmail: 'fat-boy-smiling',
  adults: 'fat-boy-smiling',
  name: 'fat-boy-smiling',
  surname: 'fat-boy-smiling',
  second_surname: 'fat-boy-smiling',
  document_type: 'credit-card',
  driving_license_state: 'credit-card',
  passport_photo_front: 'credit-card',
  id_photo_front: 'credit-card',
  id_photo_back: 'credit-card',
  document_number: 'credit-card',
  document_support_number: 'credit-card',
  expedition_date: 'credit-card',
  expiration_date: 'credit-card',
  bookingCode: 'location',
  entranceDate: 'calendar',
  departureDate: 'calendar',
  hotel: 'hotel1',
  hotelId: 'hotel1',
  children: 'child',
  birth_date: 'birthday-cake',
  sex: 'sex',
  city: 'flag',
  nationality: 'flag',
  guest_nationality: 'flag',
  phone: 'phone',
  landline_phone: 'phone',
  address: 'pin',
  zip: 'pin',
  postalCode: 'pin',
  nights: 'moon',
  download: 'download',
  upload: 'upload',
  search: 'search',
  pen: 'pen',
  delete: 'delete',
  hotel1: 'hotel1',
  hotelNot: 'hotel-not',
  default: 'check',
  email: 'mail_message_envelope_letter_icon_192475',
  password: 'fat-boy-smiling',
  check: 'checked',
  share: 'share',
  // TODO(agency-filter): map agency to the final "agent with headset" icon token when available.
  // agency: 'agent-headset-icon-token',
  country: 'flag',
  province: 'flag',
  birthCountry: 'flag',
  birthProvince: 'flag',
  birthCity: 'flag',
  arrivalTime: 'flag',
  room: 'bed_bed_room_sleep_furniture_icon_124423',
  uploadDocument1: 'credit-card',
  uploadDocument2: 'credit-card',
  uploadDocumentSignature: 'credit-card',
  documentIssuanceCountry: 'flag',
  documentIssuanceProvince: 'flag',
  payment_type: 'credit-card',
  family_relationship: 'fat-boy-smiling',
  travel_reason: 'location',
  // Temporal icons
  allergy: 'flag',
  mobilityProblems: 'flag',
  customerNotes: 'flag',
};
